import { Flex, Text } from "@/atoms"
import { useLogger } from "@/hooks/useLogger"
import { useTooltip } from "@/hooks/useTooltip"
import { useTranslation } from "@/hooks/useTranslation"
import { CreateActionEmptyTable } from "@/molecules/EmptyTable"
import { Protected } from "@/molecules/Protected"
import { useReportsJobs } from "@/pages/ReportsPage/applications/useReports"
import { getReportJob } from "@/pages/ReportsPage/applications/useReports.selector"
import { Filter } from "@/pages/SettingsPage/components/organisms/Filter"
import { downloadFileFromUrl } from "@/services/download"
import { TabTemplate } from "@/templates/TabTemplate"
import { getColumnsTable } from "./getColumnsTable"

import styles from "./WarehouseReportTab.module.scss"

import type { TabProps } from "@/pages/ReportsPage"

export const WarehouseReportTab = (props: TabProps) => {
  const [{ response, isLoading }] = useReportsJobs()
  const { data, metadata } = response || {}
  const { t } = useTranslation()
  const { logger, EVENTS } = useLogger()
  const onDownload = (
    record: ReturnType<typeof getReportJob>["data"][number]
  ) => {
    const { pdfDownloadURL } = record

    if (!pdfDownloadURL) return

    const filename =
      pdfDownloadURL?.split("?")?.[1]?.split("/")?.pop() || `${record.id}.pdf`

    downloadFileFromUrl({ filename, url: pdfDownloadURL }, { target: "_blank" })

    const { reportType, id, definitionId } = record
    const meta = { id, definitionId, reportType }

    logger.info(EVENTS.ANALYTIC_EVENTS.REPORTS.DOWNLOAD_REPORT, meta)
  }
  const { permissions, createURL } = props
  const columns = getColumnsTable({ t, onDownload, ...props })

  useTooltip(data)

  return (
    <TabTemplate<ReturnType<typeof getReportJob>["data"][number]>
      resizable
      classes={{ row: styles.row }}
      headerComponent={
        <Flex
          justify="space-between"
          align="center"
          className="sticky-section-tab-template-ks"
        >
          <Flex flex="0 0 50%">
            <Text type="secondary">{t("reports.warehouse.description")}</Text>
          </Flex>
        </Flex>
      }
      SearchComponent={<Filter />}
      columns={columns}
      metadata={metadata}
      loading={isLoading}
      dataSource={data}
      locale={{
        customEmptyComponent: (
          <Protected shouldDisable permission={permissions}>
            <CreateActionEmptyTable tKey="report" to={createURL} />
          </Protected>
        )
      }}
      onRowClick={props.onEdit}
    />
  )
}
